import React from 'react';
import { Button, Icon, Table, Form, Header, Popup, Loader, Input } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

import { IconHeader, FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';
import StudyProgramsFilter from './StudyProgramsFilter';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoFilterDataMessage = () => <p>Filtriranje je uključeno! Nema smjera (studijskog programa).</p>;
const NoDataMessage = () => <p>Nema smjera (studijskih programa).</p>;


export default class StudyPrograms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            filterData: [],
            studyPrograms: [],
            indexNumber: '',
            studentStudyProgramId: '',
            sProgramId: null,

            showFiltersOnButton: false,
            showFilterMode: false,
            loading: true,

            addIndexMode: false,
            indexNumberErr: false,

            confirmation: false,
            yes: false,
        };

        this.getDataToRender = this.getDataToRender.bind(this);
        this.getStudyPrograms = this.getStudyPrograms.bind(this);
        this.enrollStudent = this.enrollStudent.bind(this);
        this.addIndex = this.addIndex.bind(this);

        this.filtersOff = this.filtersOff.bind(this);
        this.getFilterData = this.getFilterData.bind(this);
        this.activateFilter = this.activateFilter.bind(this);
    }

    componentDidMount() {
        this.getStudyPrograms();
    }

    enrollStudent(sProgramId, index) {
        this.setState({ sProgramId });
        this.setState({ confirmation: false, addIndexMode: index });
    }

    addIndex() {
        const { indexNumber } = this.state;
        if (!indexNumber) {
            this.setState({ indexNumberErr: true });
            toast('Morate unijeti broj indexa!');
        } else {

            let obj = {
                studentId: this.props.studentId,
                studyProgramId: this.state.sProgramId
            };
            axios.post('students/study-program-enroll', { ...obj })
                .then(res => {
                    this.setState({ indexNumberErr: false });
                    let obj = {
                        studentStudyProgram: { id: res.data.id },
                        number: this.state.indexNumber
                    };
                    axios.post('students/add-identification-document', { ...obj })
                        .then(res1 => {
                            toast('Student je uspješno upisan na smjer (studijski program).');
                            toast('Studentu je uspješno dodijenjen broj indexa.');
                            this.setState({ addIndexMode: false });
                            this.getStudyPrograms();
                        })
                        .catch(err => {
                            toast('Došlo je do greške! Studentu nije dodijenjen broj indexa.');
                        });

                    // this.getStudyPrograms();
                })
                .catch(err => {
                    toast('Došlo je do greške! Student nije upisan na smjer (studijski program).');
                    this.setState({ confirmation: false });
                });
        }
    }

    getStudyPrograms() {
        let obj = {};
        axios.post(`students/study-programs/not-enrolled-in/${this.props.studentId}`, { ...obj })
            .then(res => {
                const studyPrograms = res.data.map(el => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));
                this.setState({ data: res.data, studyPrograms, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch study programs');
            });
    }

    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filterData;
        }
        return this.state.data;
    }


    getFilterData(name, durationYear, durationSemester) {
        let docFilter = {};

        if (name) docFilter = { ...docFilter, name };
        if (durationYear) docFilter = { ...docFilter, durationYear };
        if (durationSemester) docFilter = { ...docFilter, durationSemester };

        if (this.state.showFilterMode) {
            if (name || durationYear || durationSemester) {
                this.setState({ showFiltersOnButton: true, showFilterMode: false });
            } else {
                toast('Morate unijeti po čemu želite filtrirati podatke!');
            }
        }
        axios.post(`students/study-programs/not-enrolled-in/${this.props.studentId}`, { ...docFilter })
            .then(res => {
                this.setState({ filterData: res.data });
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch filter results');
                toast('Došlo je do greške! Filtriranje nije uspjelo.');
            });
    }

    filtersOff() {
        this.setState({
            showFilterMode: false, showFiltersOnButton: false,
        });
        return this.state.data;
    }
    activateFilter() {
        this.setState({ showFilterMode: !this.state.showFilterMode });
    }


    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                <Header style={IconHeader} floated="right" >
                    {this.state.showFiltersOnButton && <Button
                        onClick={this.filtersOff}
                        floated="left"
                        icon
                        labelPosition="right"
                        color="orange"
                        size="small"
                        style={FiltersOnStyle}
                    >
                        <Icon className="remove" onClick={this.filtersOff} />
                        Filtriranje uključeno!
                    </Button>}
                    <Icon />
                    <Popup
                        trigger={<Icon link circular basic="true" floated="right" name="filter" onClick={this.activateFilter} />}
                        content="Filtriranje podataka"
                        hideOnScroll
                        position="top center"
                    />
                </Header>

                {this.state.showFilterMode && <StudyProgramsFilter
                    onFilterData={this.getFilterData}
                    studyPrograms={this.state.studyPrograms}
                    filtersOff={this.filtersOff}
                />
                }


                {this.getDataToRender().length ?
                    <Table celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Odsjek</Table.HeaderCell>
                                <Table.HeaderCell>Studijski program</Table.HeaderCell>
                                <Table.HeaderCell width="2">Napomena</Table.HeaderCell>
                                <Table.HeaderCell>Trajanje (godine / semestri)</Table.HeaderCell>
                                <Table.HeaderCell>Uslovi upisa</Table.HeaderCell>
                                <Table.HeaderCell>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {this.getDataToRender().map((el, index) =>
                            (<Table.Row key={index}>
                                <Table.Cell verticalAlign="middle">
                                    {el.departments.map(e => <div>{e.name}<br /></div>)}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.description}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.durationYear} /  {el.durationSemester}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.enrollmentTerms}
                                </Table.Cell>
                                <Table.Cell textAlign="center" verticalAlign="middle">
                                    {this.state.addIndexMode === index ?
                                        <div>
                                            <h4>Unesite broj indexa studentu:</h4>
                                            <Form noValidate>
                                                <Form.Field
                                                    control={Input}
                                                    required
                                                    value={this.state.indexNumber}
                                                    onChange={(e) => this.setState({ indexNumber: e.target.value })}
                                                    name="indexNumber"
                                                    placeholder="Unesite broj indexa"
                                                    error={this.state.indexNumberErr}
                                                />
                                                <Button color="blue" onClick={this.addIndex}>Potvrdi</Button>
                                            </Form>
                                        </div>
                                        : this.state.confirmation === index ?
                                            <div>
                                                <h4>Jeste li sigurni?</h4>
                                                <Button.Group>
                                                    <Button
                                                        basic="true"
                                                        color="blue"
                                                        onClick={() => { this.enrollStudent(el.id, index); }}
                                                    > DA</Button>
                                                    <Button
                                                        basic="true"
                                                        color="red"
                                                        onClick={() => { this.setState({ confirmation: false }); }}
                                                    >  NE

                                                    </Button>
                                                </Button.Group></div>
                                            : <Button
                                                basic="true"
                                                color="blue"
                                                size="small"
                                                onClick={
                                                    () => {
                                                        this.setState({ confirmation: index });
                                                    }
                                                }
                                            >  Upiši studenta
                                            </Button>}
                                </Table.Cell>
                            </Table.Row>))}
                        </Table.Body>
                    </Table>
                    : this.state.showFiltersOnButton ?
                        <NoFilterDataMessage />
                        : <NoDataMessage />
                }
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentEnroll/StudyPrograms.js